module.exports = __webpack_public_path__ + "img/copy.256af50e.png";